<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <h2 :class="b('title')">
      {{ $t("Кошелек") }}
    </h2>

    <div :class="b('wrapper')">
      <div
        v-if="walletRepo.list.length > 0"
        :class="b('currency-section')"
        class="currency-section"
      >
        <SharedBlockCurrencySelect
          :buy-rate="selectedPairBuyRate"
          :sell-rate="selectedPairSellRate"
          @pair-changed="handlePairChanged"
        />

        <div :class="[b('pairs'), { 'with-animation': shouldAnimate }]">
          <Vue3Marquee
            :duration="shouldAnimate ? 30 : 0"
            :pauseOnHover="true"
            :gap="20"
          >
            <SharedBlockCurrencyPair
              v-for="pair in pairsWithRates"
              :key="pair.currency_id_from + pair.currency_id_to"
              :pair="pair"
              :currency-map="currencyMap"
            />
          </Vue3Marquee>
        </div>
      </div>

      <WalletMain />

      <div :class="b('group')">
        <WalletHistory :history="depositWithdrawalHistory" />

        <WalletApplications :history="applicationHistory" />
      </div>
    </div>

    <transition name="opacity">
      <component
        v-if="isModalShow"
        :class="b('modal')"
        :modal="walletRepo.modal"
        :is="displayedModal"
        @update="loadData"
        @close="closeModal"
      />
    </transition>
  </div>
</template>
